import office from '@/taskpane/officejs/office-wrapper'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import MessageArgs from '../messages/message-args'

interface OpenEmailWindowArgs extends MessageArgs {
  messageId: string
}

export default async function openEmailWindowHandler(data: OpenEmailWindowArgs) {
  const callbackArgs: CallbackArgs = defaultCallbackArgs()

  try {
    await office.ui.openEmail(data.messageId)
  } catch (error) {
    callbackArgs.errorMessage = 'Can not open requested email message'
  } finally {
    sendMessageToSidebar('OpenEmailWindowCallback', callbackArgs)
  }
}
